import { IUser } from "../interfaces";
import { BaseModel } from "./baseModel";

export class User extends BaseModel<IUser> implements IUser {
    index: number;
    first_name: string;
    last_name: string;
    mobile: string;
    email: string;
    avatar: string;
    is_anarestan: boolean;
    level_name: number;
    duration: number;
  
    constructor(data: IUser) {
      super();
      this.index = data.index;
      this.first_name = data.first_name;
      this.last_name = data.last_name;
      this.mobile = data.mobile;
      this.email = data.email;
      this.avatar = data.avatar;
      this.is_anarestan = data.is_anarestan;
      this.level_name = data.level_name;
      this.duration = data.duration;
    }
  }